import GlobalFilterDrawer from './GlobalFilterDrawer';

export default GlobalFilterDrawer;
